/* Lucian UX/UI Prompt #276 · MIT License (c) 2026 Seokwoooo · https://lucianlabs.dev/uxui-prompt/#276 */
/* Menu Collections V3: chon nhom phong (tab doc), danh sach collection chu lon, anh san pham bay theo con tro (lo mot nhip, nghieng theo huong di).
   Bam vao dong van la lien ket that toi collection. Ban phim: focus dong thi anh hien o cuoi dong. prefers-reduced-motion: khong tre, khong nghieng. */
(function () {
  'use strict';
  var d = document, root = d.querySelector('[data-mx]'); if (!root) return;
  function qs(s, c) { return (c || d).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pv = qs('.u276-pv', root), st = qs('.u276-st', root), cells = qsa('.u276-st > i', root), rows = qsa('.u276-a', root), lists = qsa('.u276-ls', root);
  var tabs = qsa('[data-mx-tab]', root), panes = qsa('[role=tabpanel]', root);
  var loaded = false;
  function loadImages() { if (loaded) return; loaded = true; qsa('img[data-src]', root).forEach(function (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); }); }
  var toggle = d.querySelector('[data-a3-toggle="mega"]');
  if (toggle) { ['pointerenter', 'focus', 'click'].forEach(function (ev) { toggle.addEventListener(ev, loadImages, { once: true }); }); }
  root.addEventListener('pointerenter', loadImages, { once: true });

  /* ---- tab nhom phong ---- */
  function selectGroup(g, focus) {
    tabs.forEach(function (t, k) { var on = k === g; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.setAttribute('tabindex', on ? '0' : '-1'); t.classList.toggle('is-on', on); });
    panes.forEach(function (p, k) { p.hidden = k !== g; });
    pick(-1); if (focus) tabs[g].focus();
  }
  tabs.forEach(function (t, g) {
    t.addEventListener('click', function () { selectGroup(g, false); });
    t.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') selectGroup(g, false); });
    t.addEventListener('keydown', function (e) {
      var n = null; if (e.key === 'ArrowDown') n = (g + 1) % tabs.length; else if (e.key === 'ArrowUp') n = (g - 1 + tabs.length) % tabs.length; else if (e.key === 'Home') n = 0; else if (e.key === 'End') n = tabs.length - 1;
      if (n !== null) { e.preventDefault(); selectGroup(n, true); }
    });
  });

  /* ---- anh bay theo con tro (mau 276) ---- */
  var cur = -1, pos = { x: 0, y: 0 }, sp = { x: 0, y: 0 }, vx = 0, raf = 0, last = 0, anchored = false, seen = false, W = 168, H = 210;
  function measure() { W = pv.offsetWidth || W; H = pv.offsetHeight || H; }
  function pick(i) {
    if (i === cur) return; cur = i; measure();
    rows.forEach(function (b, j) { b.classList.toggle('is-on', j === i); });
    lists.forEach(function (l) { l.classList.toggle('is-hov', i >= 0); });
    var has = i >= 0 && cells[i] && cells[i].querySelector('img');
    pv.classList.toggle('is-on', !!has);
    if (i >= 0) st.style.transform = 'translateY(' + (-i * H) + 'px)';
  }
  function frame(now) {
    raf = 0;
    if (!root.isConnected || !root.offsetParent) return;
    var dt = Math.min(0.033, Math.max(0, (now - last) / 1000)); last = now;
    var rw = root.offsetWidth, rh = root.offsetHeight;
    var tx = Math.max(0, Math.min(rw - W - 6, pos.x + 22)), ty = Math.max(4, Math.min(rh - H - 4, pos.y - H / 2)), k = rm ? 1 : Math.min(1, dt * 9);
    var nx = sp.x + (tx - sp.x) * k; vx = (nx - sp.x) / Math.max(dt, 0.001); sp.x = nx; sp.y += (ty - sp.y) * k;
    var tilt = Math.max(-12, Math.min(12, vx * 0.02));
    pv.style.left = sp.x.toFixed(1) + 'px'; pv.style.top = sp.y.toFixed(1) + 'px'; pv.style.rotate = (rm ? 0 : tilt).toFixed(2) + 'deg';
    if (Math.abs(tx - sp.x) + Math.abs(ty - sp.y) > 0.5 || Math.abs(tilt) > 0.2) raf = requestAnimationFrame(frame);
  }
  function kick() { if (!raf) { last = performance.now(); raf = requestAnimationFrame(frame); } }
  rows.forEach(function (b, i) {
    b.addEventListener('focus', function () {
      anchored = true; pick(i); measure();
      var r = b.getBoundingClientRect(), rr = root.getBoundingClientRect();
      pos.x = (r.right - rr.left) - W - 70; pos.y = (r.top - rr.top) + r.height / 2;
      if (!pv.classList.contains('is-on') || !seen) { sp.x = pos.x + 22; sp.y = pos.y - H / 2; seen = true; }
      kick();
    });
    b.addEventListener('blur', function () { if (anchored) { anchored = false; pick(-1); } });
  });
  root.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'touch') return;
    var r = root.getBoundingClientRect(); pos.x = e.clientX - r.left; pos.y = e.clientY - r.top; anchored = false;
    var hit = d.elementFromPoint(e.clientX, e.clientY), b = hit && hit.closest && hit.closest('.u276-a');
    pick(b ? rows.indexOf(b) : -1);
    if (cur >= 0 && !seen) { seen = true; sp.x = pos.x + 22; sp.y = pos.y - H / 2; }
    kick();
  });
  root.addEventListener('pointerleave', function () { pick(-1); seen = false; });
})();
